import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type FiltersSavedViewsUpdateConfirmationModalProps = {
  onConfirm: () => void;
  name?: string;
};

const FiltersSavedViewsUpdateConfirmationModal = create(
  function FiltersSavedViewsUpdateConfirmationModal({
    onConfirm,
    name,
  }: FiltersSavedViewsUpdateConfirmationModalProps) {
    const modal = useModal();

    const handleOnConfirm = () => {
      onConfirm();
      modal.hide();
    };

    return (
      <ConfirmationModal
        title="Update view"
        confirmationButtonLabel="Update"
        confirmationButtonVariant="primary"
        onConfirm={handleOnConfirm}
      >
        <ConfirmationModalMessage>
          Would you like to update <strong>{name}</strong> view with the new settings?
        </ConfirmationModalMessage>
      </ConfirmationModal>
    );
  }
);

export const showFiltersSavedViewsUpdateConfirmationModal = (
  props: FiltersSavedViewsUpdateConfirmationModalProps
) => show(FiltersSavedViewsUpdateConfirmationModal, props);
